import React, { useContext, useEffect, useState } from 'react';
import './style.css';
import { AcademicYears, naacExcelGenerator, naacFetchData } from '../../../NecttosComp/APICaller/ApiServices';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { FirebaseContext } from '../../../context/FirebaseContext';
import Instruction from '../../../Documentation/Instruction';
import Button from '../../../NecttosComp/Button/Button';
import { Body, Header, Main } from '../../../NecttosComp/Layout/Layout';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../../NecttosComp/Table/Table';
function NIFR({ val, onClose }) {
	const [values, setValues] = useState();
	const { collegeId } = useContext(FirebaseContext);
	const [academicYear, setAcademicYear] = useState('2022-23');
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		naacFetchData({
			data: { collegeId, academicYear },
			setLoading,
			setValues,
			url: '/college/NIFR/',
		});
	}, []);

	useEffect(() => {
		values?.sort((a, b) => a?.department[0]?.localeCompare(b?.department[0]));
	}, [values]);

	console.log({ values });

	return (
		<>
			<Main title='NIFR' width='90%' height='90%'>
				<Header>
					<div></div>
					<div className='flex'>
						<Button
							type='download'
							onClick={() =>
								naacExcelGenerator({
									data: { collegeId, academicYear },
									setLoading,
									url: '/college/NIFR/',
								})
							}>
							Dowload
						</Button>
						<Instruction keyId={'NIFR'}></Instruction>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</Header>
				<Body width='100%'>
					{loading ? (
						<div className='fixed top-0 left-0 h-screen w-screen flex justify-center items-center bg-[#0000004f]'>
							<LoadingAnimation />
						</div>
					) : null}

					<Table width='100%' innerWidth={['5%', '10%', '12%', '6%', '12%', '10%', '10%', '8%', '8%', '7%', '6%', '12%']}>
						<Thead>
							<Tr>
								<Th position={0}>Sl. No.</Th>
								<Th position={1}>Department</Th>
								<Th position={2}>Name</Th>
								<Th position={3}>Gender</Th>
								<Th position={4}>Date of Birth / Age (as on 31-07-2023)</Th>
								<Th position={5}>Designation</Th>
								<Th position={6}>Highest Qualification</Th>
								<Th position={7}>Total Teaching Exp. (Months)</Th>
								<Th position={8}>Total Industry Exp. (Months)</Th>
								<Th position={9}>PAN</Th>
								<Th position={10}>Working or Not</Th>
								<Th position={11}>Date of Joining in Govt. Victoria College</Th>
							</Tr>
						</Thead>

						<Tbody>
							{values?.map((x, i) => (
								<Tr key={i}>
									<Td index={i} position={0}>
										{i + 1}
									</Td>
									<Td index={i} position={1}>
										{x?.department?.[0]?.replace('Department of', '')}
									</Td>
									<Td index={i} position={2}>
										{x?.name}
									</Td>
									<Td index={i} position={3}>
										{x?.gender}
									</Td>
									<Td index={i} position={4}>
										{x?.dob}
									</Td>
									<Td index={i} position={5}>
										{x?.designation}
									</Td>
									<Td index={i} position={6}>
										{x?.highestQualification}
									</Td>
									<Td index={i} position={7}>
										{x?.months}
									</Td>
									<Td index={i} position={8}>
										{''}
									</Td>
									<Td index={i} position={9}>
										{x?.panCard}
									</Td>
									<Td index={i} position={10}>
										Yes
									</Td>
									<Td index={i} position={11}>
										{x?.dateOfJoin}
									</Td>
								</Tr>
							))}
						</Tbody>
					</Table>
				</Body>
			</Main>
		</>
	);
}

export default NIFR;
